'use client';

import type { Project } from '@/types/project';
import { useTranslations } from 'next-intl';
import { CompactSection, RequiredIndicator } from './section-components';
import { GoalsQualityIndicator } from './GoalsQualityIndicator';

interface ProjectGoalsSectionProps {
  project: Project;
  projectId: string;
}

export function ProjectGoalsSection({
  project,
  projectId,
}: ProjectGoalsSectionProps) {
  const t = useTranslations('project');

  const goalsText = project.attributes.goals?.trim() || '';
  const hasGoals = goalsText.length > 0;
  // Brief now hosts the building's views (photos), so the orange required-dot is
  // the onboarding nudge for the two essential empty tasks: no view uploaded
  // yet, or an empty brief.
  const hasViews = (project.attributes.angles_count ?? 0) > 0;
  const score = project.attributes.goals_quality_score ?? null;
  const pending = !!project.attributes.is_goals_evaluation_pending;

  return (
    <CompactSection
      title={t('projectGoals')}
      href={`/project/${projectId}/goals`}
      contextContent={
        hasViews && hasGoals ? (
          // Has views and a filled brief → GSM signal-strength of the brief.
          // Orange is reserved exclusively for the empty-task indicator.
          <GoalsQualityIndicator
            score={score}
            hasGoals
            pending={pending}
            size="sm"
          />
        ) : (
          <RequiredIndicator />
        )
      }
    />
  );
}
